// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checked-value{align-items:center;display:flex;font-size:22px;font-weight:300}.checked-value label{margin:0 0 0 1rem}.checked-value label:first-letter{text-transform:capitalize}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
